export default "__VITE_ASSET__boTLO1pg__"